export const expanded = state => state.previewModalGeneric.expanded
export const index = state => state.previewModalGeneric.index
